import { RootState } from "../root.reducer";

export const travelerInformationSelector = (state: RootState) =>
  state.travelerInformation;
